import React from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { Link } from 'react-scroll';
import ButtonComp from 'atoms/Buttons/Presentation/ButtonComp';
import { getAndCheck, truncateWords } from 'common/utilities/utils';
import { TooltipView } from 'atoms/Tooltip/index';

export const checkIsDefaultItem = modifierArr => {
  const defaultMod = modifierArr?.filter(item => item?.isDefault);
  return defaultMod[0];
};
/**
 * PDP summary Component
 */
export function PdpSummaryViewComponentFunc(props) {
  const {
    pdpData,
    getDname,
    veg,
    Non_veg_dot_Icon,
    Veg_dot_Icon,
    modgrps,
    customizable,
    isActive,
    itemStatus,
    IS_OUT_OF_STOCK,
    setAsActiveLink,
    PDPEditIconDisabled,
    PDPEditIcon,
    isMobile,
    quantityUpdateTemplate,
    addToCartTemplate,
    makeItComboHandler,
    isIpad,
    comboData,
  } = props;

  const getCustomizableModgroupsViews = mod_grps => {
    return mod_grps.map(item => {
      return (
        !item.isHidden && (
          <div key={item.id} className={`pdp-receipt-modGrp-container${isActive === item.id ? ' activeGroup' : ''}`}>
            {isActive === item.id ? <span className='arrowed'></span> : null}
            <span className='pdp-receipt-modgrp'>{truncateWords(getDname(item), 14, isIpad)} :</span>
            <TooltipView id={item.id} placement='top' title={getDname(checkIsDefaultItem(item.modifiers))}>
              {
                <span className='pdp-receipt-modifiers'>
                  {truncateWords(getDname(checkIsDefaultItem(item.modifiers)), 16, isIpad)}
                </span>
              }
            </TooltipView>
            <button
              className='editIcon'
              data-testid={`set-active-link-handler-${item.id}`}
              onClick={event => setAsActiveLink(event, item.id)}
              disabled={itemStatus === IS_OUT_OF_STOCK && true}
            >
              <img
                className='pdp-summary-edit-icon'
                src={itemStatus === IS_OUT_OF_STOCK ? PDPEditIconDisabled : PDPEditIcon}
                alt='Summary Edit'
              ></img>
            </button>
          </div>
        )
      );
    });
  };

  const getNonCustomizatbleView = () => {
    return (
      <div className='d-flex item_details'>
        <label>{translateWithI18Next('mainEntree')}:</label>
        <TooltipView id='entree' placement='top' title={getDname(pdpData)}>
          {<span>{truncateWords(getDname(pdpData), 26, isIpad)}</span>}
        </TooltipView>
      </div>
    );
  };

  const quantityModifierMobView = () => {
    return (
      <div className='pdp-mobile-quantity-price fixedDiv'>
        <div className='pdp-quantity-block'>{quantityUpdateTemplate()}</div>
        {addToCartTemplate()}
      </div>
    );
  };

  const quantityModifierDesktopView = () => {
    return (
      <React.Fragment>
        <div className='pdp-quantity-block'>
          <label className='qty'>{translateWithI18Next('quantity')}</label>
          {quantityUpdateTemplate()}
        </div>
        {addToCartTemplate()}
      </React.Fragment>
    );
  };

  const getMakeItComboView = () => {
    return (
      <Link activeClass='active' className='combo-btn' to={'pdp-combo'} offset={0} spy={true} smooth={true}>
        <ButtonComp
          tabIndex='1'
          className='button whiteButton blackBorder pdp-combo-button'
          data-testid='makeitcombo-btn'
          onClickHandler={makeItComboHandler}
        >
          <span>{translateWithI18Next('makeItACombo')}</span>
        </ButtonComp>
      </Link>
    );
  };

  const customizatbleView = modgrps.length > 0 && customizable && getCustomizableModgroupsViews(modgrps);
  const nonCustomizableView = !customizable && getNonCustomizatbleView();
  const getQuantityModifier = isMobile ? quantityModifierMobView() : quantityModifierDesktopView();
  const makeItComboView = getAndCheck(!customizable, comboData > 0) && getMakeItComboView();

  return (
    <div className='pdp-receipt-card'>
      <form className='pdp-receipt-form'>
        <div className='pdp-receipt-header'>{getDname(pdpData)}</div>
        <img
          className='pdp-summary-vegOrNonVeg-icon'
          src={!veg ? Non_veg_dot_Icon : Veg_dot_Icon}
          alt='PDP Summary'
        ></img>
        <div className='pdp-receipt-veg'>
          {!veg ? translateWithI18Next('nonveg') : translateWithI18Next('veg')} • Serves 4
        </div>
        <React.Fragment>
          <div className='pdp-receipt-list'>
            {customizatbleView}
            {nonCustomizableView}
          </div>
          {getQuantityModifier}
          {makeItComboView}
        </React.Fragment>
      </form>
    </div>
  );
}

export const PdpSummaryViewComponent = React.memo(PdpSummaryViewComponentFunc);
